  function amortiziaRefreshCartCount(){
    fetch('/cart.js', { cache: 'no-store' })
      .then(r => r.json())
      .then(cart => {
        const el = document.getElementById('cartCount');
        if (el) el.textContent = cart.item_count > 0 ? ' (' + cart.item_count + ')' : '';
      })
      .catch(()=>{});
  }
  amortiziaRefreshCartCount();
  window.addEventListener('pageshow', amortiziaRefreshCartCount);

  const cookiePrefsLink = document.getElementById('cookiePrefsLink');
  if (cookiePrefsLink) {
    cookiePrefsLink.addEventListener('click', (e) => {
      e.preventDefault();
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        window.privacyBanner.showPreferences();
      }
    });
  }

  const collectionsDropdown = document.getElementById('collectionsDropdown');
  const collectionsTrigger = document.getElementById('collectionsTrigger');
  if (collectionsDropdown && collectionsTrigger) {
    collectionsTrigger.addEventListener('click', (e) => {
      e.stopPropagation();
      collectionsDropdown.classList.toggle('open');
    });
    document.addEventListener('click', (e) => {
      if (!collectionsDropdown.contains(e.target)) collectionsDropdown.classList.remove('open');
    });
  }

  const heroVideo = document.getElementById('heroVideo');
  if (heroVideo) {
    heroVideo.muted = true;
    heroVideo.playsInline = true;
    const tryPlay = () => heroVideo.play().catch(()=>{});
    tryPlay();
    document.addEventListener('DOMContentLoaded', tryPlay);
    window.addEventListener('load', tryPlay);
    ['loadedmetadata','loadeddata','canplay','canplaythrough'].forEach(evt=>{
      heroVideo.addEventListener(evt, tryPlay);
    });
    document.addEventListener('click', tryPlay, { once:true });
    document.addEventListener('scroll', tryPlay, { once:true });
    heroVideo.addEventListener('playing', () => heroVideo.classList.add('is-playing'));
  }

  if (window.matchMedia('(pointer: fine)').matches) {
    const dot = document.getElementById('cursor-dot');
    const ring = document.getElementById('cursor-ring');
    let mx=0,my=0,rx=0,ry=0;
    window.addEventListener('mousemove', e=>{
      mx=e.clientX; my=e.clientY;
      dot.style.left=mx+'px'; dot.style.top=my+'px';
    });
    function loop(){
      rx += (mx-rx)*0.18; ry += (my-ry)*0.18;
      ring.style.left=rx+'px'; ring.style.top=ry+'px';
      requestAnimationFrame(loop);
    }
    loop();
    document.querySelectorAll('.cursor-hover').forEach(el=>{
      el.addEventListener('mouseenter', ()=> ring.classList.add('grow'));
      el.addEventListener('mouseleave', ()=> ring.classList.remove('grow'));
    });
  }

  const tileObserver = new IntersectionObserver((entries)=>{
    entries.forEach(en=>{ if(en.isIntersecting){ en.target.classList.add('in'); tileObserver.unobserve(en.target); } });
  }, { threshold:0.15 });
  document.querySelectorAll('.tile').forEach(t=> tileObserver.observe(t));

  const headObserver = new IntersectionObserver((entries)=>{
    entries.forEach(en=>{ if(en.isIntersecting){ en.target.classList.add('in'); headObserver.unobserve(en.target); } });
  }, { threshold:0.4 });
  document.querySelectorAll('.reveal-head').forEach(h=> headObserver.observe(h));

  const magStage = document.getElementById('magStage');
  const magCard = document.getElementById('magCard');
  const magClose = document.getElementById('magClose');
  let magOpen = false;
  if (magStage && magCard) {
    magStage.addEventListener('mousemove', e=>{
      if (magOpen) return;
      const r = magStage.getBoundingClientRect();
      const px = (e.clientX - r.left) / r.width - 0.5;
      const py = (e.clientY - r.top) / r.height - 0.5;
      magCard.style.transform = `rotateY(${-18 + px * -22}deg) rotateX(${6 + py * 16}deg)`;
    });
    magStage.addEventListener('mouseleave', ()=>{
      if (!magOpen) magCard.style.transform = 'rotateY(-18deg) rotateX(6deg)';
    });
    magCard.addEventListener('click', (e)=>{
      if (magOpen && magClose && !magClose.contains(e.target)) return;
      magOpen = !magOpen;
      magCard.classList.toggle('open', magOpen);
      magCard.style.transform = magOpen ? 'rotateY(180deg) rotateX(0deg)' : 'rotateY(-18deg) rotateX(6deg)';
    });
  }

  const typeLine = document.getElementById('typeLine');
  if (typeLine) {
    const fullText = '> AVAILABLE ON WOLF & BADGER';
    const typeObserver = new IntersectionObserver((entries)=>{
      entries.forEach(en=>{
        if (en.isIntersecting) {
          typeObserver.unobserve(en.target);
          let i = 0;
          const timer = setInterval(()=>{
            typeLine.textContent = fullText.slice(0, i);
            i++;
            if (i > fullText.length) {
              clearInterval(timer);
              const cursor = document.createElement('span');
              cursor.className = 'win95-cursor';
              typeLine.appendChild(cursor);
            }
          }, 45);
        }
      });
    }, { threshold:0.5 });
    typeObserver.observe(typeLine);
  }

  const preloader = document.getElementById('preloader');
  const heroContent = document.querySelector('.hero-content');
  const revealPage = () => {
    if (preloader) preloader.classList.add('hide');
    if (heroContent) heroContent.classList.add('in');
  };
  if (document.readyState === 'complete') {
    setTimeout(revealPage, 300);
  } else {
    window.addEventListener('load', () => setTimeout(revealPage, 850));
  }
  setTimeout(revealPage, 3000);

  const signupPopup = document.getElementById('signupPopup');
  const popupBackdrop = document.getElementById('popupBackdrop');
  const popupClose = document.getElementById('popupClose');
  if (signupPopup) {
    let popupShown = false;
    let popupDismissed = false;
    const openPopup = () => {
      if (popupShown || popupDismissed) return;
      popupShown = true;
      signupPopup.classList.add('show');
    };
    const closePopup = () => {
      popupDismissed = true;
      signupPopup.classList.remove('show');
    };
    if (document.readyState === 'complete') {
      setTimeout(openPopup, 10000);
    } else {
      window.addEventListener('load', () => setTimeout(openPopup, 10000));
    }
    popupClose.addEventListener('click', closePopup);
    popupBackdrop.addEventListener('click', closePopup);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closePopup();
    });
  }

  const newsletterForm = document.getElementById('newsletterForm');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function(e){
      e.preventDefault();
      const formData = new FormData(newsletterForm);
      fetch(newsletterForm.action, { method: 'POST', body: formData })
        .then(() => {
          newsletterForm.innerHTML = '<p style="color:var(--bone);font-size:13px;letter-spacing:.02em;">Thank you &mdash; you\'re on the list.</p>';
        })
        .catch(() => {
          newsletterForm.innerHTML = '<p style="color:var(--bone);font-size:13px;letter-spacing:.02em;">Something went wrong. Please try again.</p>';
        });
    });
  }

  const lightbox = document.getElementById('tileLightbox');
  if (lightbox) {
    const lightboxImg = document.getElementById('lightboxImg');
    const lightboxTitle = document.getElementById('lightboxTitle');
    const lightboxLink = document.getElementById('lightboxLink');
    const lightboxClose = document.getElementById('lightboxClose');
    const lightboxBackdrop = document.getElementById('lightboxBackdrop');
    const lightboxPrev = document.getElementById('lightboxPrev');
    const lightboxNext = document.getElementById('lightboxNext');
    const lightboxDots = document.getElementById('lightboxDots');

    let currentImages = [];
    let currentIndex = 0;

    const renderDots = () => {
      lightboxDots.innerHTML = '';
      if (currentImages.length <= 1) return;
      currentImages.forEach((_, i) => {
        const dot = document.createElement('span');
        if (i === currentIndex) dot.classList.add('active');
        lightboxDots.appendChild(dot);
      });
    };

    const showImage = (i) => {
      currentIndex = (i + currentImages.length) % currentImages.length;
      const img = currentImages[currentIndex];
      lightboxImg.src = img.src;
      lightboxImg.alt = img.alt;
      renderDots();
    };

    const openLightbox = (tile) => {
      currentImages = Array.from(tile.querySelectorAll('.tile-img-wrap img'));
      if (!currentImages.length) currentImages = Array.from(tile.querySelectorAll('img'));
      const title = tile.querySelector('.tile-title');
      lightboxTitle.textContent = title ? title.textContent : '';
      lightboxLink.href = tile.getAttribute('href');
      const multi = currentImages.length > 1;
      lightboxPrev.classList.toggle('is-hidden', !multi);
      lightboxNext.classList.toggle('is-hidden', !multi);
      showImage(0);
      lightbox.classList.add('show');
    };
    const closeLightbox = () => lightbox.classList.remove('show');

    document.querySelectorAll('#dark-romance .tile, #collection .tile, #purgatory .tile, #poison .tile, .rtw-tile').forEach(tile=>{
      tile.addEventListener('click', (e)=>{
        if (window.matchMedia('(max-width:820px)').matches) {
          e.preventDefault();
          e.stopPropagation();
          openLightbox(tile);
        }
      });
    });

    lightboxPrev.addEventListener('click', (e)=>{ e.stopPropagation(); showImage(currentIndex - 1); });
    lightboxNext.addEventListener('click', (e)=>{ e.stopPropagation(); showImage(currentIndex + 1); });

    lightboxLink.addEventListener('click', (e)=>{
      e.preventDefault();
      e.stopPropagation();
      const dest = lightboxLink.getAttribute('href');
      if (dest && dest !== '#') window.location.href = dest;
    });

    let touchStartX = 0;
    lightboxImg.addEventListener('touchstart', (e)=>{ touchStartX = e.touches[0].clientX; }, { passive:true });
    lightboxImg.addEventListener('touchend', (e)=>{
      const dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 40) { dx < 0 ? showImage(currentIndex + 1) : showImage(currentIndex - 1); }
    }, { passive:true });

    lightboxClose.addEventListener('click', closeLightbox);
    lightboxBackdrop.addEventListener('click', closeLightbox);
    document.addEventListener('keydown', (e) => {
      if (!lightbox.classList.contains('show')) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowRight') showImage(currentIndex + 1);
      if (e.key === 'ArrowLeft') showImage(currentIndex - 1);
    });
  }